module.exports = __webpack_public_path__ + "img/20201030_shanghai_chinaaid.99056313.jpg";